import React, {Component} from 'react';
import 'assets/sass/dashboard/buy-and-sell/CurrencyInput.scss';
import {MoneyField} from "buenLib/components/MoneyField";
import { AppContext } from 'app/state/AppContext';

export class CurrencyInput extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            isFocus: false,
            isFilled: false,
        };

        this.handleBlur = this.handleBlur.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
    }

    handleFocus() {
        this.setState({isFocus: true});
    }

    handleBlur(event) {
        const value = event.target.value;
        this.setState({isFilled: value.length !== 0, isFocus: false});
    }

    renderCurrency() {
        // TODO refactor: this.props.currency should always be a currency object
        if (this.props.currency.code) {
            return this.props.currency.code();
        }
        const { getCurrencyInstance } = this.context;
        return getCurrencyInstance(this.props.currency).code();
    }

    classNames() {
        return 'currency-input' +
            (this.state.isFocus ? ' focus' : '') +
            (this.state.isFilled ? ' filled' : '') +
            (this.props.field.hasErrors() ? ' max' : '');

    }

    render() {
        // TODO refactor: this.props.currency should always be a currency object
        const currencyCode = this.props.currency.lowercaseCode ? this.props.currency.lowercaseCode() : this.props.currency;
        return (
            <div className={this.classNames()}>
                <MoneyField value={this.props.field.value()} name={this.props.name} currency={this.props.currency}
                            onChange={this.props.handleChange} onBlur={this.handleBlur} onFocus={this.handleFocus}
                            displayType={'input'} thousandSeparator={""} decimalScale={this.props.decimalScale}
                            fixedDecimalScale={false}
                            placeholder={"0"} autoComplete={"off"}/>
                <div className="input-label">{this.props.label}</div>
                <div className={`${currencyCode} currency`}>{this.renderCurrency()}</div>
                {/*<div className="input-max" onClick={this.setMaxBalanceValue}>MAX</div>*/}
                <div className="max-buy-and-sell">{this.props.field.error()}</div>
            </div>
        );
    }
}
